export default {
  selected: 'Selecionado',
  deselect_all_selected_options: 'Desmarcar todas as opções selecionadas',
  expanded: 'Expandido',
  collect: 'Coletar',
  no_options_available: 'Nenhuma opção disponível',
  required: 'Obrigatório',
  input_clear_aria_label: 'Limpar entrada',
  input_show_hide_password_aria_label: 'Mostrar ou ocultar senha',
  input_increment_aria_label: 'Aumentar valor',
  input_decrement_aria_label: 'Diminuir valor',
  english: 'Inglês',
  chinese: 'Chinês',
  portuguese: 'Português',
  spanish: 'Espanhol',
  dutch: 'Holandês',
  french: 'Francês',
  german: 'Alemão',
  russian: 'Russo',
  ukrainian: 'Ucraniano',
  korean: 'Coreano',
  italian: 'Italiano',
  czech: 'Tcheco',
  access_your_account: 'Acesse sua conta',
  use_your_company_credentials_to_get_started:
    'Use suas credenciais da empresa para começar',
  this_link_has_expired: 'Este link expirou',
  login: 'Login',
  sample_no_production_date_message:
    'A data de fabricação deve ser selecionada',
  free_comment: 'Comentário livre',
  save_comments: 'Salvar & Fechar',
  round_list_rounds: 'Rodadas',
  round_edit_round: 'Editar Rodada',
  round_new_round: 'Nova Rodada',
  round_remove_round: 'Tem certeza que deseja excluir a Rodada?',
  round_schedule: 'Agendamento',
  round_tasters_unselect_all: 'Desmarcar todos',
  round_tasters_select_all: 'Marcar todos',
  round_close: 'Finalizar Rodada',
  round_close_message: 'Tem certeza que deseja finalizar a rodada?',
  round_create_site_message: 'Você está criando uma Rodada para outra Unidade!',
  round_closed_message: 'Você não pode editar uma Rodada fechada',
  round_status_created: 'Criado',
  round_status_samples: 'Amostras',
  round_status_scheduled: 'Agendado',
  round_status_tasters: 'Degustadores',
  round_status_in_progress: 'Em andamento',
  round_status_finished: 'Finalizado',
  round_status_closed: 'Fechado',
  round_schedule_start_finish_date:
    'A data de início não pode ser posterior à data de término',
  round_schedule_finish_date_no_start_date:
    'Você deve selecionar uma data de início primeiro',
  round_disabled_discussion_tooltip:
    'Você não pode acessar uma discussão de uma Rodada inacabada',
  round_up_down_maintenance_tooltip:
    'Este recurso está em manutenção e está temporariamente indisponível',
  round_delete_other_users_rounds:
    'Você não está autorizado a excluir uma Rodada que não criou',
  round_randomize_samples_order_button: 'Embaralhar',
  round_block_results_tooltip:
    'Bloquear os resultados desta Rodada para que eles não possam ser baixados na tela de relatórios. Se o botão estiver desabilitado, você não tem o privilégio de bloquear os resultados das Rodadas deste local',
  round_block_results_confirm:
    'Tem certeza que deseja bloquear/desbloquear os resultados da Rodada?',
  round_block_results_no_privilege:
    'Você não tem o privilégio de bloquear / desbloquear os resultados da Rodada deste local.',
  sample_list_samples: 'Amostras',
  sample_edit_sample: 'Editar Amostra',
  sample_new_sample: 'Nova Amostra',
  sample_remove_sample: 'Remover Amostra',
  sample_upload_document: 'Anexar Documentos',
  sample_download_documents: 'Documentos da amostra',
  sample_tasted_dates: 'Datas de Prova',
  sample_upload_message:
    'Para enviar múltiplos arquivos, adicione-os em um .zip',
  sample_not_for_kpi: 'Não é KPI',
  sample_package: 'Embalagem',
  sample_volume: 'Volume',
  sample_production_date: 'Data de Produção',
  sample_expire_date: 'Validade',
  sample_trial_identifier: 'Identificador do Ensaio',
  sample_project_name: 'Nome do Projeto',
  sample_linked: 'Em nenhuma Rodada',
  sample_expire_bigger_than_production:
    'A Data de Produção não pode ser maior que a Data de Validade',
  sample_no_site_message:
    'É obrigatório selecionar uma Zona, um País e uma Cervejaria para criar uma amostra',
  sample_no_brand_message: 'É obrigatório selecionar uma Marca',
  sample_duplicated_kpi_message:
    'Já existe um KPI para o Mês, Marca e Cervejaria que você selecionou e você não poderá salvar',
  sample_duplicated_kpi_message_quarter:
    'Já existe um KPI para o trimestre, marca e site que você selecionou e não será possível salvar.',
  sample_duplicated_project_message:
    'Já existe uma amostra com este Nome do Projeto e Identificador do Ensaio para esta Cervejaria e Marca, e você não será capaz de salvar',
  sample_project_no_name_or_trial:
    'O Nome do Projeto e o Identificador do ensaio são obrigatórios ao criar uma amostra do tipo Projeto',
  sample_production_to_project_confirm_message:
    'Você está alterando o tipo desta amostra de PRODUÇÃO para PROJETO. Você deseja continuar?',
  sample_project_to_production_confirm_message:
    'Você está alterando o tipo desta amostra de PROJETO para PRODUÇÃO. Você deseja continuar?',
  sample_no_volume_message:
    'Embalagem e Volume são obrigatórios ao criar/editar uma amostra.',
  sample_id_code_message: 'Por favor inclua o número completo do lote',
  sample_show_all_samples_hint:
    'Mostrando amostras criadas até um ano a partir de hoje. Marque esta caixa se você quiser ver amostras mais antigas também',
  sample_show_all_samples_label: 'Mostrar Todas As Amostras',
  package_duplicate: 'Já existe uma embalagem com este nome',
  common_production: 'Produção',
  day: 'dia',
  common_project: 'Projeto',
  group_list_groups: 'Grupos',
  group_edit_group: 'Editar Grupo',
  group_new_group: 'Novo Grupo',
  group_remove_group: 'Remover Grupo',
  group_close_modal: 'Fechar',
  group_duplicated_user: 'Este usuário já foi adicionado a este grupo!',
  group_no_name_message: 'É necessário inserir um nome de grupo',
  group_no_zone_message: 'É necessário selecionar uma zona',
  group_no_users_message: 'É necessário selecionar pelo menos um provador',
  family_list_families: 'Estilos',
  family_edit_family: 'Editar Estilo',
  family_new_family: 'Novo Estilo',
  family_remove_family: 'Remover Estilo',
  families_page_description:
    'Gerencie todos os estilos e suas configurações em um só lugar',
  family_new_page_description:
    'Preencha as informações do estilo e conclua a criação.',
  family_edit_page_description: 'Edite as informações do estilo.',
  family_save_success: 'Estilo criado com sucesso!',
  family_update_success: 'Estilo atualizado com sucesso!',
  family_save_failed: 'Falha ao salvar estilo.',
  family_save_success_desc: 'Confira nos estilos abaixo.',
  family_update_success_desc: 'Confira nos estilos abaixo.',
  family_save_failed_desc: 'Tente novamente em alguns instantes.',
  the_name_is_duplicated: 'O nome está duplicado.',
  common_style_name: 'Nome do Estilo',
  common_warning: 'Aviso',
  enter_language: 'Digite {{language}}',
  cancel_new_family_title: 'Cancelar novo estilo?',
  cancel_edit_family_title: 'Cancelar edição do estilo?',
  cancel_new_family_confirm: 'Cancelar novo estilo',
  cancel_edit_family_confirm: 'Cancelar edição do estilo',
  family_remove_success: 'Estilo removido com sucesso',
  family_remove_failed: 'Falha ao remover estilo',
  family_delete_title: 'Excluir estilo?',
  family_delete_description:
    'O estilo {{name}} será removido permanentemente. Tem certeza de que deseja continuar?',
  family_delete_success: 'Estilo excluído com sucesso!',
  family_delete_success_desc: 'O estilo foi removido.',
  family_delete_failed: 'Falha ao excluir estilo.',
  family_delete_failed_desc: 'Tente novamente em alguns instantes.',
  family_has_no_english_name:
    'Atenção: o nome do Estilo em inglês é obrigatório',
  brand_list_brands: 'Marcas',
  brand_edit_brand: 'Editar Marca',
  brand_new_brand: 'Nova Marca',
  brand_remove_brand: 'Remover Marca',
  brand_profile_picture: 'Salvar foto de perfil da marca',
  brand_upload_brand_logo: 'Enviar Logo da Marca',
  brand_duplicate: 'Atenção: Existe uma Marca com este nome',
  brand_has_no_english_name:
    'Deve preencher uma marca e um perfil de cerveja correspondente',
  brand_upload_help_message: 'Somente arquivos PNG e JPG',
  brand_has_no_product_type: 'Você deve selecionar um tipo de produto',
  package_list_packages: 'Embalagens',
  package_edit_package: 'Editar Embalagem',
  package_new_package: 'Nova Embalagem',
  package_remove_package: 'Remover Embalagem',
  package_has_no_english_name:
    'Atenção: o nome em inglês da Embalagem é obrigatório',
  package_volumes: 'Volumes',
  package_new_volume: 'Novo Volume',
  package_remove_volume: 'Remover Volume',
  degree_list_degrees: 'Intensidades',
  degree_edit_degree: 'Editar Intensidade',
  degree_new_degree: 'Nova Intensidade',
  degree_remove_degree: 'Remover Intensidade',
  category_list_categories: 'Categorias',
  category_edit_category: 'Editar Categoria de Sabor',
  category_new_category: 'Nova Categoria de Sabor',
  category_remove_category: 'Remover Categoria de Sabor',
  comment_list_comments: 'Atributos',
  comment_edit_comment: 'Editar Atributo de Sabor',
  comment_new_comment: 'Novo Atributo de Sabor',
  comment_remove_comment: 'Remover Atributo de Sabor',
  comment_cancel_new_title: 'Cancelar novo atributo de sabor?',
  comment_cancel_edit_title: 'Cancelar edição do atributo de sabor?',
  comment_cancel_new_confirm: 'Cancelar novo atributo de sabor',
  comment_cancel_edit_confirm: 'Cancelar edição do atributo de sabor',
  comment_successfully_created: 'Atributo de sabor criado com sucesso!',
  comment_successfully_created_desc: 'Confira no atributo abaixo.',
  comment_successfully_updated: 'Atributo de sabor atualizado com sucesso!',
  comment_successfully_updated_desc: 'Confira no atributo abaixo.',
  comment_create_failed: 'Falha ao criar o atributo de sabor.',
  comment_update_failed: 'Falha ao atualizar o atributo de sabor.',
  comment_failed_desc: 'Tente novamente em instantes.',
  comment_delete_title: 'Excluir atributo?',
  comment_delete_description:
    'O atributo {{name}} será removido permanentemente. Tem certeza de que deseja continuar?',
  comment_delete_success: 'Atributo excluído com sucesso!',
  comment_delete_success_desc: 'Confira no atributo abaixo.',
  comment_delete_failed: 'Falha ao excluir o atributo.',
  comment_delete_failed_desc: 'Tente novamente em instantes.',
  user_list_users: 'Usuários',
  user_edit_user: 'Editar Usuário',
  user_new_user: 'Novo contratante da ABI',
  user_export_users: 'Exportar Usuários',
  user_list_profiles: 'Perfis',
  user_profile_name: 'Nome do Perfil',
  user_profile_select: 'Selecione um Perfil',
  user_remove_user: 'Remover Usuário',
  user_profile_remove: 'Remover Perfil',
  user_profile_save: 'Salvar Perfil',
  user_use_terms: 'Aceitou Termos de Uso',
  report_list_report: 'Relatórios',
  report_start_date: 'Data de início',
  report_end_date: 'Data final',
  common_privileges: 'Privilégios',
  common_abi_name: 'Nome ABI',
  common_id: 'ID',
  common_ranked: 'Classificada',
  common_week: 'Semana',
  common_weeks: 'Semanas',
  common_days: 'Dias',
  common_category: 'Sabor',
  common_category_sample: 'Categoria',
  common_degree: 'Intensidade',
  common_comment: 'Comentário',
  common_status: 'Status',
  common_zone: 'Zona',
  common_country: 'País',
  common_site: 'Cervejaria',
  common_start_date: 'Data de início',
  common_finish_date: 'Data de término',
  common_round_type: 'Tipo de Teste',
  common_type: 'Tipo',
  common_round: 'Rodada',
  common_round_id: 'ID da Rodada',
  common_tasters: 'Degustadores',
  common_sample_performance: 'Desempenho da amostra',
  common_taste: 'Sabor',
  common_key_taster: 'Degustador Principal',
  common_sample: 'Amostra',
  common_samples: 'Amostras',
  common_sample_type: 'Tipo de Amostra',
  common_family: 'Estilo',
  common_brand: 'Marca',
  common_product_type: 'Tipo de Produto',
  common_temperature: 'Condição de armazenamento',
  common_storage_times: 'Tempo de armazenamento',
  common_sku: 'SKU',
  common_batch: 'Código de Identificação',
  common_kpi_month: 'Mês KPI',
  common_logo: 'Logo',
  common_name: 'Nome',
  common_notes: 'Notas',
  common_email: 'E-mail',
  common_language: 'Idioma',
  common_terms_of_use: 'Termos de Uso',
  common_profile: 'Perfil',
  common_filter: 'Filtro de Usuários',
  common_download: 'Gerar',
  download: 'Baixar',
  common_save: 'Salvar',
  common_cancel: 'Cancelar',
  cancel_add_taster_title: 'Cancelar adição do degustador?',
  cancel_add_taster_description:
    'Você já selecionou degustadores. Ao cancelar, sua seleção será descartada. Deseja continuar?',
  cancel_add_taster_confirm: 'Cancelar adição do degustador',
  cancel_enter_concentration_title: 'Cancelar a inserção da concentração?',
  cancel_enter_concentration_description:
    'Você inseriu um valor de concentração. Ao cancelar, a entrada não salva será descartada. Deseja continuar?',
  cancel_enter_concentration_confirm: 'Cancelar inserção da concentração',
  common_search_users: 'Buscar Usuários',
  common_search_group: 'Buscar Grupo',
  common_search_taster: 'Buscar Degustador',
  common_no_data: 'Nenhum registro encontrado',
  common_edit: 'Editar',
  no_results_found_for_applied_filters:
    'Nenhum resultado encontrado para os filtros aplicados',
  common_loading: 'Carregando...',
  common_search: 'Pesquisar...',
  type_more_characters: 'Digite mais {{count}} caractere(s)...',
  common_cannot_be_empty: 'O campo {{field}} não pode estar vazio',
  common_select_option: 'Selecione Opção...',
  search_placeholder: 'Pesquisar...',
  no_search_results: 'Nenhum resultado encontrado',
  clear_selection: 'Limpar seleção',
  common_per_page: 'Linhas por página',
  common_attributes: 'Atributos',
  common_not_started: 'Não Iniciado',
  common_in_progress: 'Em andamento',
  common_finished: 'Concluído',
  common_start: 'Início',
  common_detail: 'Ver Detalhes',
  common_delete: 'Excluir',
  common_position: 'Posição',
  common_average_key_score: 'Pontuação chave média ',
  common_score: 'Ponto',
  common_score_scale: 'Escala de pontuação',
  common_intensity: 'Intensidade',
  common_report_not_have_data: 'As rodadas selecionadas não tiveram votos',
  month_0: 'Janeiro',
  month_1: 'Fevereiro',
  month_2: 'Março',
  month_3: 'Abril',
  month_4: 'Maio',
  month_5: 'Junho',
  month_6: 'Julho',
  month_7: 'Agosto',
  month_8: 'Setembro',
  month_9: 'Outubro',
  month_10: 'Novembro',
  month_11: 'Dezembro',
  dropdown_change_picture: 'Trocar foto',
  dropdown_language: 'Idioma',
  dropdown_logout: 'Sair',
  logout_title: 'Saindo, por favor aguarde…',
  logout_description: 'Você está saindo da sua conta.',
  round_not_started: 'Não Iniciado',
  round_in_progress: 'Em andamento',
  round_finished: 'Concluído',
  round_filter_start: 'Início',
  tasting_list_rounds: 'Lista de rodadas',
  menu_tasting_session: 'Sessão de Degustação',
  menu_panel_management: 'Painel de Gestão',
  menu_process_management: 'Gestão de Processos',
  menu_product_management: 'Gestão de Produto',
  menu_attributes_management: 'Gestão de Atributos',
  tasting_finish_sample: 'Finalizar Amostra',
  tasting_comments: 'Comentários',
  tasting_beer_profile: 'Cerveja Perfil',
  tasting_need_select_score_comments:
    'Você deve definir uma pontuação e adicionar pelo menos um comentário para continuar ...',
  tasting_finish_taste: 'Finalizar Prova',
  tasting_finish_tasting: 'Finalizar Prova',
  common_no_comments: 'Sem Comentários',
  previous_comments: 'Comentários anteriores',
  review_submit_title: 'Você realmente deseja finalizar sua degustação?',
  review_submit_description:
    'Você não poderá editar seus comentários e pontuações depois!',
  review_finish_taste: 'Finalizar Degustação',
  review_warning_sample_title: 'Você tem amostras não degustadas!',
  review_warning_sample_description: 'Você deseja continuar sem avaliá-las?',
  review_warning_sample_review: 'Revisar',
  review_warning_sample_ok: 'Continuar',
  review_warning_preference_description:
    'Por favor, selecione uma preferência antes de continuar.',
  review_warning_tie_sample_title: 'Você tem amostras empatadas!',
  review_warning_tie_sample_description:
    'Você não pode continuar sem ranqueá-las!',
  review_warning_tie_sample_review: 'Revisar',
  common_submit: 'Submeter',
  common_discussion: 'Discussão',
  discussion_order_number: 'Ordenar Por Posição',
  discussion_order_brewery: 'Ordenar Por Cervejaria',
  discussion_order_ranking: 'Ordenar Por Ranking',
  discussion_order_brand: 'Ordenar Por Marca',
  discussion_order_score: 'Ordenar Por Pontos',
  discussion_order_key_score: 'Ordenar Por Pontuação Chave',
  discussion_order_overall_rank: 'Classificar por classificação geral',
  discussion_order_key_rank: 'Ordenar por classificação de chave',
  discussion_key_ranking: 'Classificação chave',
  discussion_export_error: 'O arquivo não pode ser salvo!',
  discussion_ranking: 'Classificação',
  discussion_overall_ranking: 'Classificação geral',
  common_brewery: 'Cervejaria',
  common_trial_identifier: 'ID Ensaio',
  common_key_score: 'Pontuação Principal',
  round_report: 'Exportar para Excel',
  common_comments: 'Comentários',
  common_message_empty_profile:
    'Nome do perfil não permitido vazio ou em branco',
  common_message_out_score_range: 'pontuação fora da faixa',
  tasting_need_select_score: 'Você deve definir uma pontuação primeiro!',
  common_category_name: 'Categoria',
  categories_new_category: 'Nova categoria',
  categories_remove_category: 'Deseja remover mesmo a categoria?',
  categories_list_categories: 'Listagem de Categorias',
  common_category_sample_name: 'Amostras',
  categories_new_category_sample: 'Nova amostra',
  categories_remove_category_sample: 'Deseja remover mesmo a amostra?',
  categories_list_categories_samples: 'Listagem de Amostras',
  common_duplicate: 'Duplicar',
  common_collection_point: 'Ponto de Coleta',
  common_collection_date: 'Data de Coleta',
  common_brew_number: 'Número da fabricação/MES número',
  common_need_explain_nok: 'Você não pode ter amostras NOK sem um comentário!',
  common_show_all: 'Mostrar Tudo',
  common_import: 'Importar',
  common_download_template: 'Download modelo',
  common_create_action: 'Criar ação',
  common_action_list: 'Lista de ações',
  common_create_action_description:
    'Preencha os detalhes da ação para esta amostra.',
  common_optional: 'opcional',
  action_deadline: 'Prazo',
  action_description: 'Descrição da ação',
  action_description_autofill_tooltip: 'Descrição da ação',
  action_description_autofill_tooltip_description:
    'Gerado automaticamente (ID da rodada / Cervejaria / Nome da amostra / Data de produção / Usuário criador) + descrição adicional',
  action_owner: 'Responsável',
  action_meeting: 'Reunião do log de interação',
  action_meeting_list: 'Reunião IAL',
  action_producing_site: 'Local de produção',
  action_production_date: 'Data de produção',
  action_closed_time: 'Hora de fechamento',
  action_meeting_placeholder: 'Por favor, selecione uma reunião',
  action_status: 'Status',
  action_status_draft: 'Rascunho',
  action_status_not_started: 'Não iniciado',
  action_status_in_progress: 'Em andamento',
  action_status_delayed: 'Atrasado',
  action_status_close: 'Fechar',

  action_menu_close: 'Fechar',
  common_view_details: 'Ver detalhes',
  action_cancel: 'Cancelar',
  action_add_comment: 'Adicionar comentário',
  action_status_canceled: 'Cancelado',
  status_record: 'Registro de Status',
  no_status_record: 'Sem registros de status',
  action_type: 'Tipo de ação',
  action_create_user: 'Usuário criador',
  action_create_time: 'Data de criação',
  action_creator: 'Criador',
  action_root_cause: 'Causa raiz',
  action_description_placeholder: 'Por favor, insira a descrição da ação...',
  action_comment_added: 'Comentário adicionado com sucesso',
  action_comment_add_failed: 'Falha ao adicionar comentário',
  action_comment_placeholder: 'Digite seu comentário...',
  action_status_changed_with_comment: 'Status alterado com comentário',
  required_comment_banner:
    'Como você não é o proprietário desta ação, é necessário fornecer um comentário em nome do proprietário.',
  cancel_and_comment: 'Cancelar e comentar',
  close_and_comment: 'Fechar e comentar',
  action_edit_action: 'Editar ação',
  action_owner_placeholder: 'Por favor, selecione um responsável',
  action_created_successfully: 'A ação foi criada com sucesso!',
  action_created_successfully_desc: 'Confira a ação criada na lista de ações.',
  action_updated_successfully: 'A ação foi atualizada com sucesso!',
  action_updated_successfully_desc:
    'Confira a ação atualizada na lista de ações.',
  action_create_failed: 'Ocorreu um problema ao criar a ação',
  action_update_failed: 'Ocorreu um problema ao atualizar a ação',
  action_save_failed_desc: 'Tente novamente em alguns instantes.',
  action_deleted_successfully: 'A ação foi excluída com sucesso!',
  action_deleted_successfully_desc: 'Confira na lista de ações.',
  action_delete_failed: 'Ocorreu um problema ao excluir a ação',
  delete_action_confirm_title: 'Excluir ação?',
  delete_action_confirm_description:
    'Esta ação será removida permanentemente. Tem certeza de que deseja continuar?',
  action_added_notification: '[{{userName}}] adicionou uma nova ação',
  action_updated_notification: '[{{userName}}] atualizou sua ação',
  action_deleted_notification: '[{{userName}}] excluiu sua própria ação',
  view_action_list: 'Ver Lista de Ações',
  common_need_volte_first: 'Você não pode comentar amostras sem antes votar!',
  common_yes: 'Sim',
  common_no: 'Não',
  common_only_kpi_sample: 'Apenas Amostra KPI',
  common_name_template: 'Nome do modelo',
  interaction_log: 'Log Interação',
  common_all: 'Todos',
  common_continue: 'Continuar',
  common_minimum_score: 'Mín',
  common_maximum_score: 'Máx',
  common_average_score: 'Média',
  file_upload_fail:
    'Falha ao fazer o upload do arquivo, os seguintes erros ocorreram: ',
  file_upload_success_with_error:
    'O upload foi bem sucedido exceto pelo seguinte: ',
  missing_fields: 'campos faltando',
  column_error: 'erro de coluna',
  common_line: 'Linha',
  file_no_samples: 'Nenhuma amostra encontrada no arquivo!',
  file_success_upload: 'Sucesso ao fazer o upload do arquivo!',
  file_duplicated_kpi_project: 'KPI ou Projeto duplicado!',
  round_schedule_maximum_length:
    'O tamanho máximo do nome da rodada é de 40 caracteres.',
  sample_malt_varieties: 'Variedades de Malte',
  malt_varieties_has_no_english_name:
    'Você deve ter pelo menos um nome de variedade de malte.',
  malt_varieties_duplicate:
    'Atenção: Existe uma variedade de malte com este nome',
  malt_varieties_remove: 'Remover variedade de malte',
  common_back: 'Voltar',
  common_next: 'Próximo',
  malt_varieties_new: 'Nova Variedade',
  malt_varieties_edit: 'Editar Variedade',
  malt_varieties_enter_name: 'Digite o nome',
  malt_varieties_page_description:
    'Gerencie todas as variedades de malte e suas configurações em um só lugar.',
  malt_varieties_save_success: 'Variedade de malte criada com sucesso!',
  malt_varieties_save_success_desc: 'Confira nas variedades de malte abaixo.',
  malt_varieties_update_success: 'Variedade de malte atualizada com sucesso!',
  malt_varieties_update_success_desc: 'Confira nas variedades de malte abaixo.',
  malt_varieties_delete_title: 'Remover variedade de malte?',
  malt_varieties_delete_description:
    'A variedade de malte {{name}} será removida permanentemente. Tem certeza de que deseja continuar?',
  malt_varieties_delete_success: 'Variedade de malte excluída com sucesso!',
  malt_varieties_delete_success_desc: 'Confira nas variedades de malte abaixo.',
  malt_varieties_delete_failed: 'Falha ao excluir a variedade de malte.',
  malt_varieties_delete_failed_desc: 'Tente novamente em instantes.',
  cancel_new_malt_variety_title: 'Cancelar nova variedade de malte?',
  cancel_edit_malt_variety_title: 'Cancelar edição da variedade de malte?',
  cancel_new_malt_variety_confirm: 'Cancelar nova variedade de malte',
  cancel_edit_malt_variety_confirm: 'Cancelar edição da variedade de malte',
  reports_no_dates: 'Data de início e data de término são obrigatórias!',
  reports_date_range_message:
    'O intervalo de datas não pode ser superior a 1 ano',
  round_save_select_site: 'Para salvar uma rodada você deve selecionar um site',
  common_error: 'Ops! Algo deu errado. Por favor tente novamente',
  common_supplier: 'Fornecedor',
  common_flavor: 'Sabor',
  concentration_of_the_base_beer: 'Concentração do produto base',
  common_unit: 'Unidade',
  threshold_aml_method: 'Método AML (Ascending Method of Limits)',
  threshold_component_concentration: 'Concentração do componente',
  threshold_sample_different_help: 'Qual amostra é diferente?',
  threshold_each_set_random_order: 'Em cada Conjunto, uma ordem diferente.',
  threshold_select_base_beer: 'Selecione a Cerveja base',
  common_horizontal: 'Horizontal',
  common_unity: 'Unidade',
  common_finish_session: 'finalizar Sessão',
  common_filters: 'Filtros',
  review_submit_threshold: 'Tem certeza de que deseja salvar?',
  threshold_coder_wrong: 'Seu código está errado. Informe o código correto!',
  threshold_didnt_enter_the_code: 'Digite o número do seu lugar',
  code: 'Código',
  common_batch_code: 'Código de lote',
  threshold_samples_required: 'Cerveja base e Sabor são campos obrigatórios',
  threshold_information_helper_sample:
    'Para salvar informações da amostra, clique no botão Salvar para manter suas alterações',
  code_digits: 'Digite o código de 3 dígitos atribuído a você',
  threshold_sample_spiked_with:
    'Em cada conjunto, escolha a amostra que foi enriquecida com ',
  threshold_code_already_tasted:
    'Este código já foi provado por outro usuário. Digite outro código.',
  common_kpi_brands: 'Marcas de KPI',
  common_year: 'Ano',
  common_new_kpi_brand: 'Nova marca de KPI',
  common_action: 'Ação',
  kpi_brand_details_title: 'Detalhes da KPI Brand',
  kpi_brand_details_description:
    'Visualize informações completas e o status do processo de aprovação.',
  approval_action: 'Ação de Aprovação',
  select_approval_action: 'Selecione uma ação de aprovação',
  reject_reason_title: 'Motivo da Rejeição',
  reject_reason_description: 'Por favor, forneça um motivo para a rejeição.',
  reject_reason_label: 'Motivo da rejeição',
  reject_reason_placeholder: 'Digite o motivo da rejeição...',
  reject_reason_placeholder_site:
    "Digite o motivo da rejeição para este site '{{site}}'...",
  common_confirm: 'Confirmar',
  common_success: 'Sucesso',
  common_save_failed: 'Falha ao salvar. Tente novamente.',
  approval_status_saved_success: 'Status de aprovação salvo com sucesso!',
  common_comment_by_category: 'Comentários por categoria',
  common_alphabetic_comment: 'Comentários em ordem alfabética',
  common_name_pts_code: 'Código PTS',
  common_name_pts_code_placeholder: 'Código',
  common_name_process_item: 'Item do Processo',
  common_name_process_item_placeholder: 'Item',

  kpi_only_numbers_warning: 'Informe apenas números.',
  kpi_max_number_range_warning: 'O valor deve ser entre 1 e 9',
  kpi_already_selected_brand_warning:
    'Você já selecionou esta marca, por favor selecione outra.',
  kpi_no_kpi_informed_warning: 'Você não informou nenhum KPI',
  kpi_select_year_warning: 'Selecione o ano',
  kpi_select_site_warning: 'Selecione o site',
  kpi_existing_configuration_warning:
    "Você já tem KPI's para este site e ano cadastrado.",
  kpi_target_empty_warning: 'Um valor para uma das marcas está em branco.',
  kpi_saved_successfully: 'Suas alterações foram salvas com sucesso!',
  kpi_submitted_successfully: 'Sua submissão foi enviada com sucesso!',
  kpi_max_decimals_warning: 'Informe até no máximo 3 números decimais.',
  kpi_count_as_kpi_sample: 'Contar como KPI',
  report_list_report_kpi: 'Relatórios KPI',
  report_list_report_taste: 'Relatórios de Degustação',
  select_brand_to_filter: 'Selecione uma Marca Global!',
  select_year_to_filter: 'Selecione um ano!',
  samples_uncheck_kpi_sample_tooltip:
    'Desmarque esta caixa se não quiser que esta amostra conte no KPI',
  reports_mandatory_zone_filter: 'Selecione pelo menos uma zona',
  submission_type: 'Tipo de confirmação',
  custom_scale_title: 'Escala personalizada',
  custom_scale_grid_header_score: 'Pontuação',
  custom_scale_grid_header_ageind_scale: 'Escala de Envelhecimento Forçado',
  the_value_cannot_be_null: 'Valor não pode ser nulo!',
  unique_id: 'Identifica exclusivamente',
  report_filter_rounds_description:
    'Você deve selecionar os campos obrigatórios para carregar as opções de rodadas.',
  reports_mandatory_test_type: 'Selecione o tipo de teste.',
  round_reports_month_warning:
    'O período entre a data de início e a data de término deve ser de no máximo 6 meses.',
  zone_can_not_empty: 'A região não pode estar vazia',
  error_loading_data:
    'Erro ao carregar os dados. Verifique sua conexão e recarregue.',
  beer_batch: 'Lote de Cerveja',
  list_of_beers: 'Lista de Cerveja',
  random: 'Aleatório',
  preview: 'Prévia',
  select_the_flavor: 'Selecione o sabor',
  flavor_threshold: 'Limiar de Sabor',
  input_digital_number: 'Insira o número digital',
  concentration: 'Concentração',
  flavor_order: 'Ordem de Sabor',
  last: 'Último',
  tasting: 'Degustação',
  tasting_page_description:
    'Realize a avaliação de degustação da amostra e discuta o resultado.',
  confirmation: 'Confirmação',
  do_you_confirm_the_evaluation_of_this_sample:
    'Você confirma a avaliação desta amostra?',
  confirm: 'Confirmar',
  evaluate: 'Avaliar',
  correct_answer: 'Resposta Correta',
  threshold: 'Limiar',
  let_a_comment_about_the_tasting: 'faça um comentário sobre a degustação',
  send: 'Enviar',
  right_now: 'Imediatamente',
  minute_ago: 'minuto atrás',
  hour_ago: 'hora atrás',
  day_before: 'dia atrás',
  year_ago: 'ano atrás',
  add_a_flavor: 'Adicione um sabor',
  soft_drinks: 'Refrigerantes',
  soft_drinks_brand: 'Marca de refrigerante',
  soft_drinks_brand_target: 'Alvo da marca de refrigerantes',
  column_options: 'Opções de coluna',
  configure_table_title: 'Personalizar colunas',
  configure_table: 'Configurar tabela',
  configure_table_description: 'Escolha as colunas visíveis e ajuste a ordem.',
  configure_table_helper:
    'Pelo menos 2 colunas devem estar visíveis e no máximo 4 colunas podem ser fixadas.',
  configure_table_fixed_left: 'Fixa à esquerda',
  configure_table_scroll_area: 'Área de rolagem',
  configure_table_fixed_right: 'Fixa à direita',
  configure_table_empty_left:
    'Arraste uma coluna para aqui para fixá-la à esquerda',
  configure_table_empty_right:
    'Arraste uma coluna para aqui para fixá-la à direita',
  configure_table_save: 'Salvar alterações',
  configure_table_reset: 'Redefinir para o padrão',
  configure_table_discard: 'Descartar alterações',
  configure_table_show: 'Mostrar',
  configure_table_hide: 'Ocultar',
  configure_table_min_visible: 'Pelo menos 2 colunas devem permanecer visíveis',
  configure_table_max_fixed: 'Você pode fixar no máximo 4 colunas',
  configure_table_drag: 'Arraste para reordenar',
  configure_table_dragging: 'Arrastando',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Selecione quais das colunas deseja exibir.',
  countdown: 'contagem regressiva',
  less_than_five_minutes:
    'Esta sessão de degustação terminará em 5 minutos, se você precisar prosseguir, entre em contato com o administrador para adiar a data de término.',
  the_countdown_to_the_evaluation_has_ended:
    'A contagem regressiva para comentários terminou. Não é possível acessar os comentários.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Calcule quanto tempo você precisa para provar as amostras',
  only_six_flavors_can_be_added_at_most:
    'Só podem ser adicionados até seis sabores!',
  concentration_of_the_flavor: 'Concentração do sabor',
  input_value: 'Valor de entrada',
  Concentration_of_the_flavor_is_required:
    'A concentração do sabor é necessária',
  previous_round: 'Rodada anterior',
  next_round: 'Próxima rodada',
  the_end_time_is_greater_than_the_current_time:
    'O tempo final deve ser maior do que o tempo atual, se selecionar no mesmo dia que o dia atual, selecione a hora e o minuto primeiro!',
  check_the_answer_at_the_end_of_the_countdown:
    'A contagem regressiva não terminou, você pode ver as respostas após a contagem regressiva',
  incremental_step: 'Etapa Incremental',
  set3_concentration: 'Concentração Set3',
  concentration_increments_between_levels:
    'Aumentos de concentração entre níveis',
  incremental_set3_concentration_required:
    'Passo incremental e concentração Set3 são necessárias',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'O número da Sprint deve ser maior que 0',
  sprint_notes_at_least_one_note:
    'As notas de sprint devem ter pelo menos uma nota',
  sprint_patch_notes_success_update:
    'Notas de patch do Sprint atualizadas com sucesso.',
  sprint_patch_notes_error_update: 'Não foi possível salvar as notas.',
  sprint_number: 'Número da corrida',
  sprint_patch_notes: 'Notas do patch de sprint',
  note: 'Nota',
  select_all: 'Selecionar Tudo',
  please_add_samples_first: 'Por favor, adicione a amostra primeiro',
  reverse: 'Reversão',
  new_test: 'Testes adicionados',
  triangle_test_name: 'Nome do teste de triangulação',
  triangle_test: 'Teste de triangulação',
  you_can_not_set_three_identical_samples:
    'Não pode definir as mesmas três opções',
  its_mandatory_to_input_test_name: 'Por favor, preencha o nome do teste',
  its_mandatory_to_input_sample_information:
    'Por favor, preencha as informações da amostra',
  attention: 'Atenção',
  test_number: 'Número de série do teste de triangulação',
  you_selected_the: 'Escolheu',
  next_sample: 'Próxima amostra',
  remove_triangle_test: 'Remover Teste de Triângulo',
  you_can_only_select_up_to_five: 'Um máximo de cinco seleções são permitidas',
  test: 'Teste',
  confirm_remove: 'Confirmar a exclusão do teste?',
  reports_mandatory_zone_country_site_filter:
    'Regiões, países, fábricas são necessárias!',
  reports_mandatory_brand_filter: 'Selecione pelo menos uma marca',
  reports_by_producing_site: 'Relatório de análise completa',
  download_label: 'Botão de download',
  standard: 'Valor forfetário',
  input_test: 'Entrada de resultados',
  detecting: 'Detecção...',
  connected: 'Conectado',
  current_taster: 'Avaliadores atuais',
  alcohol_concentration: 'Concentração de álcool',
  alcohol_result_submit_failed_title:
    'Ocorreu um problema ao enviar o resultado',
  alcohol_result_submit_failed_desc: 'Tente novamente em instantes.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    'A sua concentração de álcool no sangue está excessiva. Por favor, teste novamente mais tarde!',
  alcohol_test_qualified: 'Passar no teste de alcoolemia',
  alcohol_concentration_configuration: 'Configuração da concentração de álcool',
  breathalyzer_configuration_description:
    'Configure a concentração de álcool de cada local e o estado de condução dos utilizadores.',
  breathalyzer_configuration_save_success_title: 'A configuração do bafômetro foi atualizada com sucesso!',
  breathalyzer_configuration_save_success_description: 'Confira as configurações atualizadas nos ajustes abaixo.',
  breathalyzer_configuration_save_failed_title: 'Ocorreu um problema ao atualizar a configuração do bafômetro',
  breathalyzer_configuration_save_failed_description: 'Tente novamente em alguns instantes.',
  cancel_configuration_title: 'Cancelar configuração?',
  cancel_configuration_description: 'Você fez alterações na configuração. Cancelar descartará suas alterações não salvas. Deseja continuar?',
  cancel_configuration_confirm: 'Cancelar configuração',
  driving_configuration: 'Configuração de condução',
  configuration: 'Configuração',
  input_result: 'Entrada de resultados',
  maximum_alcohol_concentration: 'Excesso de concentração de álcool',
  breathalyzer: 'Bafômetro',
  breathalyzer_page_description:
    'Gerencie todos os resultados do bafômetro e seus padrões de configuração em um só lugar.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Digite um número positivo até {{field}} casas decimais',
  you_must_input: 'Você precisa digitar',
  driving: 'Direção',
  test_time: 'Tempo de Teste',
  input_type: 'Tipo de Entrada',
  list_breathalyzer: 'Bafômetro',
  Manual: 'Manual',
  auto: 'Automático',
  Breathalyzer: 'Bafômetro',
  you_do_not_have_privilege_to_export_this_report:
    'Você não tem privilégio de exportar este relatório',
  competitor_beer: 'Cerveja concorrente',
  split_round: 'Dividir a Rodada',
  reset: 'Redefinir',
  how_many_rounds_splitting_do_you_want_to_make:
    'Quantas rodadas de divisão você quer fazer',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'Você não pode dividir uma rodada que já tenha sido dividida ou em andamento',
  hide_sample_details: 'Esconder os Detalhes da Amostra',
  hide_sample_details_auto_hide:
    'SIM - você pode dividir as amostrar e exibir automaticamente todas as informações ocultas após a degustação de todas as rodadas divididas.',
  hide_sample_details_manual_hide:
    'Manual - você não pode dividir as amostras e precisa designar um administrador temporário para alternar manualmente Reexibir ou Ocultar na página de discussão.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Os dados serão ocultos do provador: Cervejaria, Data de produção, Marca, Variedade de malte e ID da amostra',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    'Se essa rodada for selecionada como Manual, a função de divisão não estará disponível; você pode escolher Auto Ocultar ou Sem Ocultar para dividir.',
  data_will_be_hidden_for_ok_nok:
    'Todos os dados relevantes serão ocultos dos provadores.',
  you_can_not_add_duplicate_attributes:
    'Você não pode adicionar atributos duplicados.',
  menu: 'MENU',
  link_breathalyzer: 'Conectado',
  not_link_breathalyzer: 'Desconectado',
  breathalyzer_to_link: 'Conectar o Bafômetro',
  breathalyzer_connection_failed_title: 'Falha ao conectar o bafômetro',
  breathalyzer_connection_failed_desc: 'Atualize a página e tente novamente.',
  breathalyzer_can_not_to_link_for_this_browser:
    'A funcionalidade do bafômetro foi desenvolvida para funcionar no Google Chrome, usando dispositivos de PC.',
  reopen: 'Reabrir',
  round_reopen_message: 'Tem certeza que quer reabrir a Rodada',
  common_production_line: 'Linha de produção',
  common_packaged_beer_data_code: 'Código de Dados da Cerveja Embalada',
  common_masking_process_for_bottles: 'Processo de mascaramento para garrafas',
  common_str_number_days_over_aged: 'Número de dias em idade superior',
  common_over_aged_beer: 'Cerveja envelhecida',
  sample_successfully_swapped: 'Amostra trocada com sucesso.',
  scoring: 'Pontuação',
  configure_available_flavors: 'Configurar os Sabores Disponíveis',
  process_check: 'Verificação do Processo',
  new_process_check: 'Nova Verificação de Processo',
  edit_process_check: 'Editar a Verificação do Processo',
  remove_process_check: 'Remover a Verificação do Processo',
  common_package: 'Pacote',
  common_department: 'Departamento',
  common_shift: 'Turno',
  common_tank: 'Tanque',
  common_oknok: 'OKNOK',
  common_remark: 'Observação',
  show_all_process_check: 'Mostrar toda a Verificação do Processo',
  show_all_process_check_help_circle:
    'Exibe os dados criados dentro de meio ano a partir de hoje. Se você ainda precisa ver os dados criados dentro de um ano a partir de hoje, marque esta caixa',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'A data da amostra não pode ser anterior ao horário atual!',
  common_job_position: 'cargo',
  decimal_sep: 'Separador decimal',
  is_swapped_to: 'é trocado para',
  review_warning_comment_title: 'Você tem amostras não comentadas!',
  continuous_typing: 'Digitação Contínua',
  continuous_typing_tips:
    "Continue digitando 'Atributo' depois de selecionar/digitar 'Intensidade'.",
  BSSI_Reports: 'BSSI Relatórios',
  data_analysis_sip: 'Análise de Dados - SIP',
  select_the_color: 'Selecione a cor',
  color: 'Cor',
  download_document: 'Arquivos para download',
  Month_of_Discontinued_Production: 'Mês descontinuado',
  Suspension_List: 'Lista descontinuada',
  New_Suspension: 'Novo pedido descontinuado',
  new_suspension_page: 'Nova informação descontinuada',
  edit_suspension_page: 'Editar informações descontinuadas',
  Brand_name: 'Nome da marca',
  List_Brewery_Production_Suspension: 'Lista de fábricas descontinuadas',
  Upload_successfully: 'Arquivo enviado com sucesso',
  training_materials: 'Materiais de Treinamento',
  Remove_Suspension: 'Remover suspensão: ',
  Add_Absence_Reason: 'Adicionar motivo de ausência',
  Reason: 'Razão',
  Select_reason: 'Selecionar motivo',
  You_have_duplicate_absence_dates: 'Você tem datas de ausência duplicadas',
  Remove_Absence: 'Remover ausência: ',
  Absence_Title:
    'Selecione o horário e o motivo da sua ausência na degustação. Consulte ou elimine os registos em Motivo submetido.',
  Shipping_Site: 'Local de Envio',
  shipping_received: 'Envio Recebido',
  receive_sample_alert: 'Tem certeza de que recebeu a amostra?',
  receive_uncheck_alert: 'Tem certeza de que deseja desmarcá-lo?',
  all_received: 'Todos Recebidos',
  not_all_received: 'Nem todos receberam',
  not_for_shipping: 'Não para envio',
  receive_hint: 'Selecione todos os sites que receberão este exemplo',
  absence_reason: 'Motivo da Ausência',
  Page1: 'Página {{field}}',
  Search: 'Procurar',
  page_total: 'Número total',
  start_date: 'Data de início',
  end_date: 'Data de término',
  ok_for_all: 'OK para todos',
  its_mandatory_to_select_sample_A_and_sample_B:
    'É obrigatório selecionar a amostra A e a amostra B.',
  its_mandatory_to_select_sample_A: 'É obrigatório selecionar a amostra A.',
  its_mandatory_to_select_sample_B: 'É obrigatório selecionar a amostra B.',
  triangle_comment: 'Comentário',
  select_sample: 'Selecionar amostra',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Filtro de data de amostra, últimos 7 dias em padrão, exporte para Excel com base neste período filtrado.',
  select_all_flavor: 'Selecionar tudo',
  deselect_all: 'Desmarcar tudo',
  email_distribution: 'Destinatários do Relatório Mensal',
  new_email_distribution: 'Novos Destinatários do Relatório Mensal',
  edit_email_distribution: 'Editar Destinatários do Relatório Mensal',
  distribution_type: 'Tipo de Distribuição',
  the_score_entered_is_invalid:
    'A pontuação inserida é inválida. Por favor, consulte a escala de pontuação e insira sua pontuação novamente.',
  service_now:
    'Clique para criar um ticket de incidente para relatar um problema e obter ajuda.',
  service_now_tips:
    'Ei, se você vir algum problema ou gostaria de pedir suporte, você pode clicar aqui e relatá-lo diretamente no ServiceNow, nossa equipe de suporte entrará em contato com você o mais rápido possível.',
  done: 'Feito',
  changes_you_made_may_not_be_saved:
    'As alterações que você fez podem não ser salvas. Você quer continuar e perder mudanças?',
  cannel_auto_save_tips:
    'Agora que o desempenho da página de degustação melhorou, lembre-se de clicar em Finalizar Amostra para salvar e enviar seu resultado de degustação.',
  list_email_page_tips:
    'Esta é a instrução de como configurar a amostra correta do KPI, a fim de garantir que o Relatório Mensal da Zona possa refletir a análise exata para a degustação do MCS da sua zona',
  list_email_page_helps:
    'As instruções de como configurar uma amostra de KPI para refletir dados exatos no Relatório Mensal da Zona.',
  kpi_instruction: 'Instrução do KPI',
  group_no_recipients_message: 'É necessário pelo menos um destinatário.',
  the_current_distribution_type_already_exists:
    'O tipo de distribuição atual já existe, selecione novamente o tipo ou volte à lista.',
  add_samples: 'Adicionar amostra(s) à rodada',
  copy_this_sample: `Duplicar a amostra`,
  remove_this_sample: `Remover a amostra`,
  drag_samples_here: `Arraste as amostras para aqui`,
  drop_here: `Solte aqui`,
  multiple_selection_tips: `Você pode selecionar várias amostras de uma só vez para o mesmo tipo de amostra. Clique em "+" e "-" para experimentar.`,
  all_add_once_tips: `Clique no botão "Select All" (Selecionar tudo) para adicionar automaticamente uma amostra a cada tipo de amostra selecionado.`,
  copy_confirm_tip: `Tem certeza de que deseja replicar a amostra?`,
  user_non_abi_user: 'Novo usuário temporário',
  language_of_email_invitation: 'Idioma do convite por e-mail',
  add_non_abi_users_to_round:
    'O usuário temporário receberá um convite por e-mail com um link para participar da degustação específica.',
  change_non_abi_users_to_round:
    'O degustador temporário que você convidou receberá um convite por e-mail com um link para participar dessa degustação.',
  guest: 'Convidado',
  email_to_all: 'E-mail para todos',
  send_email: 'Enviar e-mail de convite',
  temporary_non_abi_taster: 'Provador temporário',
  user_type: 'Tipo de usuário',
  email_invitation_delivery_request_sent:
    'Solicitação de convite por e-mail enviada.',
  incorrect_e_mail_formatting: 'Formatação incorreta do e-mail',
  all_tasters: 'Todos os Provadores',
  tasters: 'Provadores',
  key_tasters: 'Provadores Principais',
  non_key_tasters: 'Provadores Não Principais',
  taster_already_started_cannot_change:
    'O provador já começou, não pode ser alterado',
  temporary: 'Usuário temporário',
  maximum_number_of_samples_is: `O número máximo de amostras é`,
  sample_added: 'Amostra adicionada',
  click_to_view_scale_of_flavour_intensities: `Clique no link para ver as escalas de intensidade detalhadas`,
  list_next_week_plan: 'Plano para a próxima semana',
  common_time_zone: 'Fuso horário',
  common_last_response_time: `Hora da última resposta`,
  new_week_plan: 'Plano da nova semana',
  invited_week: 'Semana convidada',
  email_language: `Idioma do e-mail`,
  save_and_send_email: `Salvar e enviar e-mail`,
  common_start_time: 'Hora de início',
  common_end_time: 'Hora de término',
  session_name_email_subject: `Nome da sessão / Assunto do e-mail`,
  location: 'Localização',
  edit_week_plan: 'Editar plano da semana',
  email_response: 'Resposta por e-mail',
  round_remove_plan: 'Tem certeza de que deseja apagar a rodada',
  view_week_plan: 'Exibir plano semanal',
  are_you_confirming_to_send_the_confirmation_email: `Você está confirmando o envio do e-mail de confirmação`,
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation: `A cada 10 minutos, o sistema atualizará a resposta de e-mail do convite do plano da próxima semana`,
  documents_upload_tips: 'Os uploads de arquivos suportam apenas {{field}}',
  ignore_submit: 'Ignorar&Enviar',
  if_count_as_kpi:
    'Se conta como KPI, a amostra é salva no histórico de amostras',
  confirmed_count: 'Contagem confirmada',
  accepted: 'Aceito',
  declined: 'Recusado',
  no_response: 'Sem resposta',
  reminder_time: 'Hora do lembrete',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    'Tem certeza de que deseja remover o horário de início/fim da sessão que selecionou e mudar para outra semana convidada',
  apply_to_all_sessions_location_tasters: `Aplique 'Localização' e 'Tasters' às seguintes sessões`,
  mcs_tasting: 'Degustação KPI',
  qcs_tasting: 'Degustação KPI',
  mcs_tasting_tips:
    'Selecione Sim (Yes) se essa rodada contiver amostras MCS/KPI, o sistema aplicará o Código KPI relacionado de acordo com a marca da amostra.',
  round_samples_shuffle_confirm:
    'Tem certeza de que deseja embaralhar os conjuntos?',
  all_count_as_kpi: 'Todos contam como KPI',
  msc_tasting_tour_mask:
    'O sistema identificará automaticamente o código de KPI relacionado com base na amostra contada com o mês de KPI correto, para que você NÃO precise dividir marcas diferentes em uma rodada',
  competition: 'Concorrência',
  copy_link: 'Copiar link',
  open_link: 'Abrir link',
  common_download_img: `Baixar o IMG`,
  please_select_taster: 'Selecione a degustação',
  user_principal_name: 'Nome do usuário principal',
  user_status: 'Status do usuário',
  termination_date: 'Data de término',
  function_level: 'Nível de função',
  last_update_time: 'Hora da última atualização',
  system_related: 'Relacionado ao sistema',
  workday_related: 'Relacionado ao WorkDay',
  employee_id: 'ID do empregado',
  zitec_project_name: 'Nome do projeto',
  applicant: 'Requerente',
  applicant_date: 'Data do pedido',
  test_method: 'Método de teste',
  liquid_category: 'Categoria Líquida',
  conditions: 'Condições',
  time_points: 'Pontos de Tempo',
  execution_date: 'Data de Execução',
  execution_by_time_points: 'Data de execução calculada por pontos de tempo',
  invitation_start_time: 'Horário de início do convite',
  invitation_end_time: 'Horário de término do convite',
  invitation_reminder: 'Lembrete do Convite',
  application_form: 'Formulário de Pedido',
  application_form_result: 'Resultado do Formulário',
  upload_result: 'Upload de Resultado',
  zitec_sessions: 'Sessões ZITEC',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'Nova Sessão ZITEC',
  common_search_applicant: 'Buscar Requerente',
  history_record: 'Histórico',
  common_quarterly: 'Trimestral',
  common_month: 'Mês',
  kpi_report: 'Relatório KPI',
  kpi_result: 'Arquivo Anaplan',
  action_log: 'Registro de ações',
  validate_data: 'Validar os Dados',
  push_anaplan_window_open_date: 'Push Data de abertura da janela Anaplan:',
  unLock_kpi: 'Desbloquear KPI',
  lock_kpi: 'Bloquear KPI',
  locked: 'Bloqueado',
  unlocked: 'Desbloqueado',
  menu_kpi_lock: 'Bloqueio KPI',
  freshness_kpi_lock: 'Bloqueio Frescura',
  in_profile_kpi_lock: 'In Profile Bloqueio',
  are_you_sure_you_want_to_lock_kpi:
    'Tem certeza de que deseja bloquear o KPI para {{field}}',
  are_you_sure_you_want_to_unlock_kpi:
    'Tem certeza de que deseja desbloquear o KPI {{field}}',
  lock_kpi_month_zone:
    'Sua ação é restrita devido ao bloqueio da amostra de KPI que foi ativada para determinado mês e zona de KPI. Se você tiver dúvidas, entre em contato com o proprietário da zona para obter mais detalhes sobre o bloqueio de dados KPI.',
  lock_freshness_kpi_month_zone:
    'Sua ação é restrita devido ao bloqueio da amostra de KPI que foi ativada para determinado trimestre e zona de KPI. Se você tiver dúvidas, entre em contato com o proprietário da zona para obter mais detalhes sobre o bloqueio de dados KPI.',
  submit_timeout: 'Falha ao enviar, por favor tente novamente mais tarde!',
  anaplan_un_upload_tips: 'Aguarde a próxima janela aberta do Anaplan!',
  anaplan_un_confirm_tips:
    'Por favor, confirme os dados de KPI para determinado mês!',
  confirmed: 'Confirmado',
  confirm_data: 'Confirmar os Dados',
  flavor_groups: `Grupos de sabores`,
  compound: 'Composto',
  sit_code_not_exist:
    'Este código de assento não existe, esteja ciente do formato do código de assento, como 001, 002.',
  sit_code_chose:
    'Esse código de assento foi escolhido, insira seu código de assento correto.',
  kpi_lock: 'Bloqueio do KPI',
  kpi_confirmation: 'Confirmação do KPI',
  global_kpi_lock: 'Bloqueio KPI Global',
  select_month: 'Selecione um mês',
  need_to_wait_global_lock: 'Você precisa aguardar o bloqueio global.',
  monthly_kpi_locked_zones: 'KPI mensal Zonas bloqueadas',
  flavor_confirm_save: `O tipo não selecionado '{{field}}' está nas amostras adicionadas. Se você confirmar que deseja salvar a configuração de sabor atual, as amostras correspondentes serão excluídas`,
  temporary_admin: 'Administrador temporário',
  unhide_sample_details: 'Reexibir detalhes da amostra',
  hide_sample: 'Ocultar amostra',
  download_report_timeout_error_message:
    'Tempo limite de acesso, verifique a conexão de rede.',
  you_can_only_select_up_to:
    'Você só pode selecionar até {{field}}, por favor reduza o número de opções.',
  push_anaplan: 'Push Anaplan',
  pushed: 'Conclusão do Push',
  self_evaluation_report:
    'Clique para fazer o download do Relatório de Autoavaliação',
  date_range: 'Intervalo de datas',
  kpi_month_range: 'Intervalo de meses do KPI',
  quick_select: 'Seleção rápida',
  current_month: 'Mês atual',
  current_year: 'Ano atual',
  a_whole_year: 'Um ano inteiro',
  download_self_evaluation_report: 'Download do relatório de autoavaliação',
  select_tasters: 'Selecione os provadores',
  create_ticket: 'Criar Ticket',
  sensory_intelligent_platform: 'Plataforma Inteligente Sensory - PBI',
  external_links: 'Links Externos',
  evaluation_report: 'Relatório de Avaliação',
  download_evaluation_report: 'Faça o download do relatório de avaliação',
  taster_type: 'Tipo de teste',
  taster_evaluation_tip:
    'Agora você pode clicar aqui para baixar seu Relatório de Autoavaliação!',
  admin_evaluation_tip:
    'Agora você pode clicar aqui para fazer o download do Relatório de Avaliação dos Provadores',
  kpi_sample: 'Amostra de KPI',
  add_to_download_list: 'Adicionar à lista de downloads',
  to_download_list: 'Para baixar',
  selected_tasters: 'Provas selecionadas',
  generation_time: 'Tempo de geração',
  start_month: 'Mês inicial',
  end_month: 'Mês final',
  download_all: 'Baixar tudo',
  new_physchem_tips:
    'Agora pode clicar aqui para adicionar propriedades físico-químicas para a amostra',
  view_physchem_tips: `Agora pode clicar aqui para ver as propriedades físico-químicas das amostras da rodada atual`,
  physchem_disabled_tips:
    'Não é possível visualizar o phychem quando as amostras estão ocultas',
  package_code: `Código da embalagem`,
  concentration_at_fu: 'Concentração em 1 unidade de sabor',
  base_beer: 'Cerveja base',
  flavor_intensities_scale: `Escala de intensidade de sabor`,
  flavor_unit: 'Unidade de sabor',
  add_a_sample: 'Adicionar uma amostra',
  common_kpi_quarter: 'KPI Trimestral',
  sample_duplicated_quarter_kpi_message:
    'Já existe um KPI para o trimestre, marca e site que você selecionou e não será possível salvar.',
  select_quarter: 'Selecione o trimestre',
  please_select_kpi_quarter: 'Selecione o trimestre do KPI',
  error_fields: `Campos de erro`,
  your_answer: 'Sua resposta',
  preference: 'Preferências',
  please_select_preference_group:
    'Você precisa selecionar suas preferências antes de enviar!',
  monthly_report: 'Relatório mensal',
  draft: 'Rascunho',
  confirm_send: 'Confirmar e enviar',
  sent_completion: 'Envio concluído',
  send_draft: 'Enviar rascunho',
  send_draft_monthly_report:
    'Envie o relatório mensal para o seu endereço de e-mail.',
  please_confirm_the_recipients:
    'Confirme os destinatários do relatório mensal',
  total_recipients: 'Total de destinatários',
  sending: 'Enviando',
  sending_monthly_report_tips1: `Sua solicitação está sendo processada.`,
  sending_monthly_report_tips2: `Verifique o resultado no “Registro de ações”.`,
  configure_upgrade_center: 'Configurar Centro de Atualização',
  sprint_content: 'Conteúdo do Sprint',
  release_date: 'Data de lançamento',
  add_sprint: 'Adicionar Sprint',
  sprint_materials: 'Materiais do Sprint',
  upgrade_center: 'Centro de Atualização',
  function: 'Função',
  my_evaluation_report: 'Meu relatório de avaliação',
  upgrade_center_remove_sprint_number:
    'Tem certeza de que deseja remover este número de sprint',
  sprint_version_tips: 'Clique para visualizar os materiais do sprint.',
  edit_sprint: 'Editar Sprint',
  new_sprint_tips:
    'Agora você pode clicar aqui para visualizar os materiais do sprint.',
  production_date_range: 'Intervalo de datas de produção',
  quality: 'Qualidade',
  preparation: 'Preparação',
  panel: 'Painel',
  session: 'Sessão',
  product: 'Produto',
  attribute: 'Atributo',
  common_menu_samples: 'Amostras',
  common_menu_rounds: 'Rodadas',
  common_menu_groups: 'Grupos',
  common_menu_suspension_list: 'Suspensão',
  common_menu_planning_week_sessions: 'Sessões de planejamento semanal',
  common_menu_zitec_sessions: 'Sessões ZITEC',
  common_menu_brands: 'Marcas',
  common_menu_kpi_brands: 'Marcas KPI',
  common_menu_packages: 'Pacotes',
  common_menu_styles: 'Estilos',
  common_menu_malt_variety: 'Variedade de malte',
  common_menu_intensities: 'Intensidades',
  common_menu_categories: 'Categorias',
  common_menu_attributes: 'Atributos',
  common_menu_user_management: 'Gestão de usuários',
  common_menu_role_management: 'Gestão de funções',
  common_menu_permission_control: 'Controle de permissões',
  system: 'Sistema',
  select_taste_type: 'Selecionar tipo de degustador',
  select_round: 'Selecionar Rodada',
  a_previous_request_is_still_being_processed:
    'Uma solicitação anterior ainda está sendo processada. Tente novamente mais tarde.',
  select_item: 'Selecionar {{field}}',
  common_new_kpi_brand_button: 'Nova KPI brand',
  common_target: 'Meta',
  common_focus_brands: 'Marcas Foco',
  common_strategic_brands: 'Marcas Estratégicas',
  kpi_brands_new_page_description:
    'Interface de Criação de Nova KPI Brand, com funções para preencher informações da KPI Brand, enviar e salvar.',
  kpi_brands_edit_page_description:
    'Editar interface de KPI Brand, com funções para atualizar, enviar e salvar informações de KPI Brand.',
  kpi_brands_edit_page_description_prefix:
    'Visualizar e configurar KPI Brands para ',
  kpi_brands_page_description:
    'Interface de gerenciamento de KPI Brands, com funções de visualização, envio e revisão.',
  table_apply: 'Aplicar',
  table_clear: 'Limpar',
  table_search: 'Pesquisar',
  table_enter_to_filter: 'Digite para filtrar...',
  table_select_to_filter: 'Selecione para filtrar...',
  table_select_all: 'Selecionar tudo',
  table_select_all_aria: 'Selecionar todas as linhas',
  table_select_row_aria: 'Selecionar linha',
  table_filter_by: 'Filtrar por',
  table_clear_filters: 'Limpar filtros',
  table_reset_filters: 'Redefinir filtros',
  table_no_results_for_filters: 'Nenhum resultado encontrado para os filtros aplicados.',
  table_items_selected: 'itens selecionados',
  table_sort: 'Ordenar',
  table_sort_toggle: 'Clique para alternar a ordenação',
  table_no_options: 'Nenhuma opção disponível',
  table_reset: 'Redefinir',
  table_all: 'Todos',
  table_no_results: 'Nenhum resultado encontrado para os filtros aplicados',
  common_approved_at: 'Aprovado em {{date}}',
  common_rejected_at: 'Rejeitado em {{date}}',
  kpi_status_created: 'Criado',
  kpi_status_waiting_for_approval: 'Aguardando aprovação',
  kpi_status_approved: 'Aprovado',
  kpi_status_rejected: 'Rejeitado',
  kpi_action_approve: 'Aprovar',
  kpi_action_reject: 'Rejeitar',
  common_by_user: 'por {{user}}',
  pagination_aria_label_next_page: 'Ir para a próxima página.',
  pagination_aria_label_previous_page: 'Ir para a página anterior.',
  pagination_aria_label_first_page: 'Ir para a primeira página.',
  pagination_aria_label_last_page: 'Ir para a última página.',
  pagination_aria_label_input:
    'Digite a página que deseja, de 1 a {totalItems}.',
  pagination_aria_label_items_per_page:
    '{pageSize} itens por pagina selecionado, clique para alterar',
  pagination_lines_per_page: 'Linhas por página',
  pagination_total_pages: 'de {totalPages}',
  pagination_total_elements:
    '{firstItem}-{lastItem} de {totalItems} resultados',
  pagination_no_results: 'Nenhum resultado encontrado.',
  kpi_brand_successfully_saved: 'KPI brand salvo com sucesso!',
  kpi_brand_saved_description:
    'Confira na KPI brand abaixo. Este é apenas um salvamento temporário, a submissão para aprovação ainda não foi concluída.',
  kpi_brand_failed_to_save: 'Falha ao salvar KPI brand.',
  kpi_brand_save_failed_description:
    'Por favor, tente novamente em um momento.',
  kpi_brand_successfully_submitted: 'KPI brand criada com sucesso!',
  kpi_brand_submitted_description:
    'Confira na KPI brand abaixo. Por favor, verifique o andamento da aprovação na página de detalhes; esta KPI brand fica disponível somente após a aprovação.',
  kpi_brand_failed_to_submit: 'Falha ao criar KPI brand.',
  kpi_brand_submit_failed_description:
    'Por favor, tente novamente em um momento.',
  cancel_edit_package_confirm: 'Cancelar edição da embalagem',
  cancel_edit_package_title: 'Cancelar edição da embalagem?',
  cancel_new_package_confirm: 'Cancelar nova embalagem',
  cancel_new_package_title: 'Cancelar nova embalagem?',
  content_already_exists: 'Conteúdo já existe.',
  language_chinese: 'Chinês',
  language_dutch: 'Holandês',
  language_english: 'Inglês',
  language_french: 'Francês',
  language_german: 'Alemão',
  language_italian: 'Italiano',
  language_korean: 'Coreano',
  language_portuguese: 'Português',
  language_russian: 'Russo',
  language_spanish: 'Espanhol',
  language_ukrainian: 'Ucraniano',
  package_name: 'Nome da Embalagem',
  package_successfully_created: 'Embalagem criada com sucesso!',
  package_successfully_created_desc: 'Confira nas embalagens abaixo.',
  package_successfully_updated: 'Embalagem atualizada com sucesso!',
  package_successfully_updated_desc: 'Confira nas embalagens abaixo.',
  packages_edit_page_description:
    'Edite as informações da embalagem e conclua a atualização.',
  packages_new_page_description:
    'Preencha as informações da embalagem e conclua a criação.',
  packages_page_description:
    'Gerencie todos os tipos de embalagens e suas configurações em um só lugar.',
  comments_page_description:
    'Gerencie todos os atributos e suas configurações em um só lugar.',
  comments_new_page_description:
    'Preencha as informações do atributo e conclua a criação.',
  comments_edit_page_description:
    'Edite as informações do atributo e conclua a atualização.',
  comment_attribute_name: 'Nome do Atributo de Sabor',
  comment_select_category: 'Selecione a Categoria de Sabor',
  flavor_id_discussion: 'Discussão de identificação de sabores',
  view_and_discussion_for: 'Ver e discutir para',
  common_cup: 'Copo',
  tasters_joined: 'Provadores participantes',
  tasters_all_correct: 'Provadores com tudo correto',
  total_accuracy: 'Precisão total',
  accuracy: 'Precisão',
  all_correct: 'Tudo correto',
  otherwise: 'Outros',
  result: 'Resultado',
  Key: 'Principal',
  nonkey: 'Não principal',
  common_guest: 'Convidado',
  view_correct_answers: 'Ver respostas corretas',
  hide_correct_answers: 'Ocultar respostas corretas',
  change_to_table: 'Mudar para tabela',
  change_to_card: 'Mudar para cartões',
  not_answered: 'Não respondido',
  download_report_success: 'Relatórios baixados com sucesso!',
  download_report_success_desc: 'Confira-os na pasta de downloads.',
  download_self_evaluation_report_success:
    'Relatório de autoavaliação baixado com sucesso!',
  download_report_failed: 'Falha ao baixar os relatórios.',
  download_report_failed_desc: 'Tente novamente em instantes.',
  evaluation_report_add_success: 'Relatório adicionado com sucesso!',
  evaluation_report_add_success_desc:
    "Consulte-o no relatório de avaliação 'Para baixar'.",
  evaluation_report_add_failed: 'Falha ao adicionar o relatório.',
  evaluation_report_add_failed_desc: 'Tente novamente em instantes.',
  add_taster: 'Adicionar degustador',
  alcohol_concentration_result: 'Resultado da concentração de álcool',
  absence_save_success: 'Motivo da ausência adicionado com sucesso!',
  absence_save_success_desc: 'Consulte-o nas ausências enviadas.',
  submitted_absence: 'Ausências enviadas',
  no_absence_to_show: 'Não há ausências para mostrar',
  absence_delete_success: 'Motivo da ausência excluído com sucesso!',
  absence_delete_success_desc: 'Consulte a lista atualizada nas ausências enviadas.',
  absence_delete_confirm_title: 'Excluir ausência?',
  absence_delete_confirm_description: 'O registro de ausência [{{start}} - {{finish}}] será excluído permanentemente. Deseja continuar?',
  absence_delete_confirm_delete: 'Excluir',
  absence_save_failed: 'Falha ao adicionar o motivo da ausência',
  absence_save_failed_desc: 'Tente novamente em instantes.',
  absence_duplicate_date_desc:
    'Já existe um registro de ausência para a data selecionada. Não são permitidos envios duplicados.',
  absence_delete_failed: 'Falha ao excluir o motivo da ausência',
  absence_delete_failed_desc: 'Tente novamente em instantes.',
  role_management_change_role: 'Alterar função',
  role_management_reset_success: 'Permissões redefinidas com sucesso!',
  role_management_reset_success_desc: 'As permissões desta função foram redefinidas para a configuração padrão. Você pode revisá-las no Controle de permissões abaixo.',
  role_management_reset_failed: 'Falha ao redefinir permissões.',
  role_management_reset_failed_desc: 'Tente novamente em instantes.',
  role_management_switch_role_title: 'Descartar alterações?',
  role_management_switch_role_description: 'Há alterações de permissões não salvas. Alterar a função irá descartá-las. Deseja continuar?',
  role_management_switch_role_confirm: 'Alterar função',
  role_management_created: 'Função personalizada criada com sucesso!',
  role_management_created_desc: 'Confira-a no Controle de Permissões abaixo.',
  role_management_permissions_failed: 'Falha ao carregar as permissões.',
  role_management_create_failed: 'Falha ao criar a função.',
  role_management_create_required: 'Insira um nome para a função e selecione um conjunto de permissões.',
  role_management_create_failed_desc: 'Tente novamente em instantes.',
  role_management_create_duplicate: 'Este nome de função já existe!',
  role_management_create_duplicate_desc: 'Insira um nome de função diferente e tente novamente.',
  role_management_save_success: 'Permissões da função atualizadas com sucesso!',
  role_management_save_success_desc: 'As alterações foram salvas. Você pode revisá-las no Controle de Permissões abaixo.',
  role_management_save_failed: 'Falha ao salvar as alterações da função.',
  role_management_save_failed_desc: 'Tente novamente em instantes.',
  role_management_permission: 'Função',
  role_management_view: 'Visualizar',
  role_management_edit: 'Editar',
  role_management_approve: 'Aprovar',
  role_management_search: 'Pesquisar funções',
  role_management_current_role_prefix: 'Sua função atual é',
  role_management_create: 'Criar função personalizada',
  role_management_save_changes: 'Salvar alterações',
  common_apply: 'Aplicar',
  role_management_reset_title: 'Redefinir para as permissões padrão?',
  role_management_reset_tooltip: 'Redefinir permissões para a configuração de [{{parentRole}}].',
  role_management_reset_description: 'Isso redefinirá as permissões da função para a configuração padrão e removerá todas as alterações manuais. Esta ação não pode ser desfeita.',
  cancel_create_role_title: 'Cancelar a criação da função personalizada?',
  cancel_create_role_confirm: 'Cancelar criação da função',
  cancel_create_role_description: 'Você inseriu dados no formulário. Ao cancelar, todos os dados não salvos serão descartados. Deseja continuar?',
  role_management_delete_title: 'Excluir função personalizada?',
  role_management_delete_preview:
    '{{role}} será removida permanentemente. Os usuários atribuídos a essa função perderão o acesso a todas as permissões associadas a ela. Deseja continuar?',
  role_management_delete_failed: 'Falha ao excluir a função.',
  role_management_default_role: 'a função padrão',
  common_go_back: 'Voltar',
  role_management_delete_preview_no_users: 'A função personalizada “{{role}}” será removida permanentemente. Deseja continuar?',
  role_management_create_title: 'Criar função personalizada',
  role_management_role_name: 'Nome da função',
  role_management_permission_set: 'Definir permissões personalizadas com base em',
  role_management_role_name_placeholder: 'Insira o nome da função',
  role_management_permission_set_placeholder: 'Selecione uma função base',
  role_management_reset_success: 'Permissões redefinidas com sucesso!',
  role_management_reset_success_desc: 'As permissões desta função foram redefinidas para a configuração padrão. Você pode revisá-las no Controle de permissões abaixo.',
  role_management_reset_failed: 'Falha ao redefinir as permissões.',
  role_management_reset_failed_desc: 'Tente novamente em instantes.',
};
